import { Link, useParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

// サンプルデータ（病院・医師マスターと紐付け）
const patientDatabase = {
  'pat-001': {
    id: 'pat-001',
    researchId: 'R01166',
    patientId: '39-011',
    firstName: 'Kn',
    lastName: 'Ku',
    gender: '女性',
    age: 33,
    birthDate: '1990-05-15',
    diseaseName: '潰瘍性大腸炎',
    diseaseDetail: '潰瘍性大腸炎（UC）',
    treatment: 'FMT3回コース',
    primaryHospitalId: 'hosp-001',
    primaryHospitalName: 'Baseクリニック赤坂',
    transplantHospitalId: 'hosp-001',
    transplantHospitalName: 'Baseクリニック赤坂',
    primaryDoctorId: 'doc-001',
    primaryDoctorName: '吉岡 紘平',
    transplantDoctorId: 'doc-001',
    transplantDoctorName: '吉岡 紘平',
    transplantCount: 3,
    evaluation: '症状の軽度改善',
    adverseEvents: null,
    createdBy: 'user-003',
    createdByName: '吉岡 紘平',
    createdAt: '2025-05-01',
    updatedAt: '2025-11-28',
    transplantHistory: [
      { date: '2025-06-26', time: '15:00', count: 3, type: 'C2', evaluation: '症状の軽度改善', doctorName: '吉岡 紘平' },
      { date: '2025-06-14', time: '15:00', count: 2, type: 'C2', evaluation: '症状の中程度の改善', doctorName: '吉岡 紘平' },
      { date: '2025-05-14', time: '13:00', count: 1, type: 'C2', evaluation: '症状の軽度改善', doctorName: '吉岡 紘平' },
    ],
  },
  'pat-002': {
    id: 'pat-002',
    researchId: 'R01598',
    patientId: '13-079',
    firstName: 'Hrs',
    lastName: 'Itu',
    gender: '男性',
    age: 38,
    birthDate: '1985-08-20',
    diseaseName: '潰瘍性大腸炎',
    diseaseDetail: '潰瘍性大腸炎',
    treatment: '継続治療中',
    primaryHospitalId: 'hosp-004',
    primaryHospitalName: '二子玉川メディカルクリニック',
    transplantHospitalId: 'hosp-004',
    transplantHospitalName: '二子玉川メディカルクリニック',
    primaryDoctorId: 'doc-004',
    primaryDoctorName: '佐藤 健一',
    transplantDoctorId: 'doc-004',
    transplantDoctorName: '佐藤 健一',
    transplantCount: 6,
    evaluation: '症状の中程度の改善',
    adverseEvents: null,
    createdBy: 'user-006',
    createdByName: '佐藤 健一',
    createdAt: '2024-11-01',
    updatedAt: '2025-11-27',
    transplantHistory: [
      { date: '2025-11-27', time: '16:30', count: 6, type: 'B1', evaluation: '症状の中程度の改善', doctorName: '佐藤 健一' },
      { date: '2025-10-15', time: '14:00', count: 5, type: 'B1', evaluation: '症状の軽度改善', doctorName: '佐藤 健一' },
      { date: '2025-09-01', time: '14:00', count: 4, type: 'B1', evaluation: '変化なし', doctorName: '佐藤 健一' },
    ],
  },
  'pat-006': {
    id: 'pat-006',
    researchId: 'R00483',
    patientId: '25-012',
    firstName: 'Chr',
    lastName: 'Aihr',
    gender: '女性',
    age: 51,
    birthDate: '1972-07-18',
    diseaseName: '過敏性腸症候群',
    diseaseDetail: '過敏性腸症候群',
    treatment: 'FMT',
    primaryHospitalId: 'hosp-003',
    primaryHospitalName: '城谷バイオウェルネスクリニック',
    transplantHospitalId: 'hosp-003',
    transplantHospitalName: '城谷バイオウェルネスクリニック',
    primaryDoctorId: 'doc-003',
    primaryDoctorName: '城谷 昌彦',
    transplantDoctorId: 'doc-003',
    transplantDoctorName: '城谷 昌彦',
    transplantCount: 2,
    evaluation: '治癒',
    adverseEvents: null,
    createdBy: 'user-005',
    createdByName: '城谷 昌彦',
    createdAt: '2025-08-01',
    updatedAt: '2025-11-20',
    transplantHistory: [
      { date: '2025-11-20', time: '10:00', count: 2, type: 'A2', evaluation: '治癒', doctorName: '城谷 昌彦' },
      { date: '2025-10-05', time: '10:00', count: 1, type: 'A2', evaluation: '著効', doctorName: '城谷 昌彦' },
    ],
  },
  'pat-008': {
    id: 'pat-008',
    researchId: 'R01701',
    patientId: '48-002',
    firstName: 'Tky',
    lastName: 'Ymd',
    gender: '男性',
    age: 48,
    birthDate: '1975-09-03',
    diseaseName: 'うつ病',
    diseaseDetail: 'うつ病',
    treatment: 'FMT',
    primaryHospitalId: 'hosp-001',
    primaryHospitalName: 'Baseクリニック赤坂',
    transplantHospitalId: 'hosp-001',
    transplantHospitalName: 'Baseクリニック赤坂',
    primaryDoctorId: 'doc-009',
    primaryDoctorName: '佐々木 美咲',
    transplantDoctorId: 'doc-001',
    transplantDoctorName: '吉岡 紘平',
    transplantCount: 4,
    evaluation: '症状の中程度の改善',
    adverseEvents: null,
    createdBy: 'user-011',
    createdByName: '佐々木 美咲',
    createdAt: '2025-06-01',
    updatedAt: '2025-11-25',
    transplantHistory: [
      { date: '2025-11-25', time: '15:00', count: 4, type: 'B2', evaluation: '症状の中程度の改善', doctorName: '吉岡 紘平' },
      { date: '2025-10-10', time: '15:00', count: 3, type: 'B2', evaluation: '症状の軽度改善', doctorName: '吉岡 紘平' },
      { date: '2025-08-20', time: '14:00', count: 2, type: 'B2', evaluation: '変化なし', doctorName: '吉岡 紘平' },
      { date: '2025-07-05', time: '14:00', count: 1, type: 'B2', evaluation: '変化なし', doctorName: '吉岡 紘平' },
    ],
  },
}

// デフォルトデータ
const defaultPatient = patientDatabase['pat-001']

export default function PatientDetail() {
  const { id } = useParams()
  const { user } = useAuthStore()
  const patient = patientDatabase[id as keyof typeof patientDatabase] || defaultPatient

  const isAdminOrOffice = user?.role === 'admin' || user?.role === 'office'

  // アクセス権限チェック
  const hasAccess = isAdminOrOffice || 
    user?.hospitalId === patient.primaryHospitalId ||
    user?.hospitalId === patient.transplantHospitalId

  if (!hasAccess) {
    return (
      <>
        <header className="aip-main__header">
          <div className="aip-main__header-container">
            <Link to="/patients" className="aip-button aip-button--icon">
              <span className="material-symbols-outlined">arrow_back</span>
            </Link>
            <h1 className="aip-main__header-title">アクセス権限がありません</h1>
          </div>
        </header>
        <div className="aip-main__content">
          <div className="access-denied">
            <span className="material-symbols-outlined">lock</span>
            <p>この患者カルテは他の医療機関のデータのため、閲覧できません。</p>
            <Link to="/patients" className="aip-button aip-button--outline">
              患者一覧に戻る
            </Link>
          </div>
        </div>
        <style>{`
          .access-denied {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 60px;
            background-color: var(--background-primary);
            border-radius: var(--border-radius-lg);
            box-shadow: var(--shadow-sm);
            text-align: center;
          }
          .access-denied .material-symbols-outlined {
            font-size: 64px;
            color: var(--color-alert);
            margin-bottom: var(--spacing-md);
          }
          .access-denied p {
            color: var(--text-secondary);
            margin-bottom: var(--spacing-lg);
          }
        `}</style>
      </>
    )
  }

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <Link to="/patients" className="aip-button aip-button--icon">
            <span className="material-symbols-outlined">arrow_back</span>
          </Link>
          <h1 className="aip-main__header-title">患者カルテ詳細</h1>
          <div className="aip-main__header-buttons">
            <Link to={`/patients/${id}/edit`} className="aip-button aip-button--outline">
              <span className="material-symbols-outlined">edit</span>
              編集
            </Link>
          </div>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="detail-container">
          {/* 基本情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">基本情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">研究会ID</label>
                <span className="detail-field__value">{patient.researchId}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">患者ID</label>
                <span className="detail-field__value">{patient.patientId}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">氏名（子音アルファベット）</label>
                <span className="detail-field__value">{patient.lastName}{patient.firstName}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">性別</label>
                <span className="detail-field__value">{patient.gender}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">年齢</label>
                <span className="detail-field__value">{patient.age}歳</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">生年月日</label>
                <span className="detail-field__value">{patient.birthDate}</span>
              </div>
            </div>
          </section>

          {/* 病名・治療 */}
          <section className="detail-section">
            <h2 className="detail-section__title">病名・治療</h2>
            <div className="detail-grid">
              <div className="detail-field detail-field--full">
                <label className="detail-field__label">病名</label>
                <span className="detail-field__value">{patient.diseaseName}</span>
              </div>
              <div className="detail-field detail-field--full">
                <label className="detail-field__label">病名詳細</label>
                <span className="detail-field__value">{patient.diseaseDetail}</span>
              </div>
              <div className="detail-field detail-field--full">
                <label className="detail-field__label">治療</label>
                <span className="detail-field__value">{patient.treatment}</span>
              </div>
            </div>
          </section>

          {/* 担当医療機関・医師 */}
          <section className="detail-section">
            <h2 className="detail-section__title">担当医療機関・医師</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">主治医（医療機関）</label>
                <Link to={`/master/hospitals/${patient.primaryHospitalId}`} className="detail-field__value--link">
                  <span className="material-symbols-outlined">local_hospital</span>
                  {patient.primaryHospitalName}
                </Link>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">主治医（担当医師）</label>
                <Link to={`/master/doctors/${patient.primaryDoctorId}`} className="detail-field__value--link">
                  <span className="doctor-avatar-sm">{patient.primaryDoctorName.charAt(0)}</span>
                  {patient.primaryDoctorName}
                </Link>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">移植担当（医療機関）</label>
                <Link to={`/master/hospitals/${patient.transplantHospitalId}`} className="detail-field__value--link">
                  <span className="material-symbols-outlined">local_hospital</span>
                  {patient.transplantHospitalName}
                </Link>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">移植担当医師</label>
                <Link to={`/master/doctors/${patient.transplantDoctorId}`} className="detail-field__value--link">
                  <span className="doctor-avatar-sm">{patient.transplantDoctorName.charAt(0)}</span>
                  {patient.transplantDoctorName}
                </Link>
              </div>
            </div>
          </section>

          {/* 移植情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">移植情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">移植回数</label>
                <span className="detail-field__value">{patient.transplantCount}回</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">移植評価</label>
                <span className={`aip-badge aip-badge--${getEvaluationClass(patient.evaluation)}`}>
                  {patient.evaluation}
                </span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">有害事象</label>
                <span className="detail-field__value">
                  {patient.adverseEvents || 'なし'}
                </span>
              </div>
            </div>
          </section>

          {/* 移植履歴 */}
          <section className="detail-section">
            <h2 className="detail-section__title">移植履歴</h2>
            <table className="aip-table">
              <thead>
                <tr>
                  <th>移植日</th>
                  <th>時刻</th>
                  <th>回数</th>
                  <th>菌株Type</th>
                  <th>担当医師</th>
                  <th>評価</th>
                </tr>
              </thead>
              <tbody>
                {patient.transplantHistory.map((history, index) => (
                  <tr key={index}>
                    <td>{history.date}</td>
                    <td>{history.time}</td>
                    <td>{history.count}回目</td>
                    <td>{history.type}</td>
                    <td>
                      <div className="doctor-cell">
                        <span className="doctor-avatar-sm">{history.doctorName.charAt(0)}</span>
                        {history.doctorName}
                      </div>
                    </td>
                    <td>
                      <span className={`aip-badge aip-badge--${getEvaluationClass(history.evaluation)}`}>
                        {history.evaluation}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          {/* 作成者情報 */}
          <section className="detail-section detail-section--muted">
            <div className="detail-grid detail-grid--compact">
              <div className="detail-field">
                <label className="detail-field__label">作成者</label>
                <span className="detail-field__value">{patient.createdByName}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">作成日</label>
                <span className="detail-field__value">{patient.createdAt}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">最終更新日</label>
                <span className="detail-field__value">{patient.updatedAt}</span>
              </div>
            </div>
          </section>
        </div>

        {/* アクションバー */}
        <div className="action-bar">
          <Link to="/patients" className="aip-button aip-button--outline">
            戻る
          </Link>
          <div className="action-bar__right">
            <Link to={`/medical-records?patient=${id}`} className="aip-button aip-button--outline">
              <span className="material-symbols-outlined">description</span>
              診療記録
            </Link>
            <Link to={`/reservations?patient=${id}`} className="aip-button aip-button--outline">
              <span className="material-symbols-outlined">calendar_month</span>
              予約履歴
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        .detail-container {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-lg);
        }

        .detail-section {
          background-color: var(--background-primary);
          padding: var(--spacing-lg);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .detail-section--muted {
          background-color: var(--color-solid-gray25);
        }

        .detail-section__title {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: var(--spacing-md);
          padding-bottom: var(--spacing-sm);
          border-bottom: 1px solid var(--border-color);
        }

        .detail-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: var(--spacing-md);
        }

        .detail-grid--compact {
          grid-template-columns: repeat(3, 1fr);
        }

        .detail-field {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-xs);
        }

        .detail-field--full {
          grid-column: 1 / -1;
        }

        .detail-field__label {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .detail-field__value {
          font-size: 0.875rem;
          color: var(--text-primary);
        }

        .detail-field__value--link {
          display: flex;
          align-items: center;
          gap: var(--spacing-xs);
          font-size: 0.875rem;
          color: var(--color-blue600);
          text-decoration: none;
        }

        .detail-field__value--link:hover {
          text-decoration: underline;
        }

        .detail-field__value--link .material-symbols-outlined {
          font-size: 18px;
        }

        .doctor-avatar-sm {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: var(--color-blue500);
          color: white;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 0.6875rem;
          font-weight: 600;
        }

        .doctor-cell {
          display: flex;
          align-items: center;
          gap: var(--spacing-xs);
        }

        .aip-badge {
          display: inline-block;
          padding: 4px 12px;
          font-size: 0.75rem;
          font-weight: 500;
          border-radius: var(--border-radius-sm);
        }

        .aip-badge--success {
          background-color: var(--color-success-light);
          color: var(--color-success);
        }

        .aip-badge--info {
          background-color: var(--color-blue50);
          color: var(--color-blue600);
        }

        .aip-badge--warning {
          background-color: var(--color-focus-light);
          color: #8b6914;
        }

        .aip-badge--neutral {
          background-color: var(--color-solid-gray100);
          color: var(--color-solid-gray700);
        }

        .aip-badge--error {
          background-color: var(--color-alert-light);
          color: var(--color-alert);
        }

        .aip-table {
          width: 100%;
          border-collapse: collapse;
        }

        .aip-table th,
        .aip-table td {
          padding: var(--spacing-sm) var(--spacing-md);
          text-align: left;
          border-bottom: 1px solid var(--border-color);
          font-size: 0.875rem;
        }

        .aip-table th {
          background-color: var(--color-solid-gray25);
          font-weight: 500;
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .action-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: var(--spacing-lg);
          padding: var(--spacing-md);
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .action-bar__right {
          display: flex;
          gap: var(--spacing-sm);
        }

        @media (max-width: 768px) {
          .detail-grid--compact {
            grid-template-columns: 1fr;
          }

          .action-bar {
            flex-direction: column;
            gap: var(--spacing-sm);
          }

          .action-bar__right {
            width: 100%;
            flex-direction: column;
          }
        }
      `}</style>
    </>
  )
}

function getEvaluationClass(evaluation: string): string {
  if (evaluation.includes('治癒')) return 'success'
  if (evaluation.includes('著効')) return 'success'
  if (evaluation.includes('中程度')) return 'info'
  if (evaluation.includes('軽度')) return 'warning'
  if (evaluation.includes('変化なし')) return 'neutral'
  if (evaluation.includes('悪化')) return 'error'
  return 'neutral'
}
